module.exports = __webpack_public_path__ + "static/img/75-1.81f0458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/75-1.jpg
// module id = qJpZ
// module chunks = 0